'use client'
import { Button } from '@repo/ui/components/button'
import { useTranslate, type MessagesKeys } from '@repo/shared/hooks'
import { useIsDesktop } from '@repo/ui/hooks'
import { twMerge } from 'tailwind-merge'
import type { OrderBoxSubmitButtonProps } from './order-box.types'
import { AuthGuard } from '..'

export const OrderBoxSubmitButton = ({
  tab,
  onClick,
  mode,
  isLoading = false,
  tradeStatus,
}: OrderBoxSubmitButtonProps) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  const buttonText =
    mode === 'easy'
      ? tab === 'buy'
        ? t('order_buy')
        : t('order_sell')
      : tab === 'buy'
        ? t('order_submit_buy')
        : t('order_submit_sell')

  // Disable button if tradeStatus is not 'active' (includes 'off_market' and other non-active statuses)
  const isDisabled = !tradeStatus || tradeStatus !== 'active'

  return (
    <div
      className={
        !isDesktop
          ? 'bg-neutral-surface-light fixed bottom-0 left-0 right-0 p-md pt-0 sm:pt-md w-auto'
          : ''
      }
    >
      <AuthGuard className='mt-xl'>
        <Button
          type='button'
          size='lg'
          color={tab === 'buy' ? 'positive' : 'negative'}
          className={twMerge('w-full sm:mt-xl mt-0')}
          onClick={onClick}
          loading={isLoading}
          disabled={isDisabled}
        >
          {tradeStatus && tradeStatus !== 'active'
            ? t(`common_project_trade_status_${tradeStatus}` as MessagesKeys)
            : buttonText}
        </Button>
      </AuthGuard>
    </div>
  )
}
